function DashboardCard({
  title,
  value,
  subtitle,
  icon,
  variant = "default",
}) {
  return (
    <article className={`dashboard-card dashboard-card--${variant}`}>
      <div className="dashboard-card__top">
        <span className="dashboard-card__title">{title}</span>
        {icon && <span className="dashboard-card__icon">{icon}</span>}
      </div>

      <strong className="dashboard-card__value">{value}</strong>

      {subtitle && (
        <p className="dashboard-card__subtitle">
          {subtitle}
        </p>
      )}
    </article>
  );
}

export default DashboardCard;